module.exports = __webpack_public_path__ + "static/media/abs.cd073717.svg";